import(/* webpackMode: "eager" */ "/tmp/build/44575cf5/repo/apps/home/app/(auth)/forgotpassword/page.tsx");
